export const config = {
  bugsinkDsns: {
    dev: 'https://a34fd4e8cfc04c5180069b53b5150838@bugsink.high.coms-dev.aws.de.pri.o2.com/4',
    prod: undefined, // 'https://85d025243c74481ab29e352ff89f6389@micro-frontend-coms.telefonica.de/3'
  },
};
